import React from 'react';
import { ReactComponent } from 'Common/components/Icons/engineering.svg';

const Engineering = () => <ReactComponent className="MuiSvgIcon-root" />;

export default Engineering;
